"use strict";
function isRecord(value) {
  return typeof value === "object" && value !== null;
}
function matchesBatchId(id, batchId) {
  if (typeof id === "string") return id === batchId;
  if (!isRecord(id)) return false;
  const [type, identifier, bundler, ...rest] = batchId.split(":");
  return Boolean(
    type && identifier && rest.length === 0 && id.type === type && id.identifier === identifier && id.bundler === bundler
  );
}
function matchesChain(value, chainId) {
  return (typeof value === "number" || typeof value === "string") && Number(value) === chainId;
}
function isTransactionHash(value) {
  return typeof value === "string" && /^0x[0-9a-fA-F]{64}$/.test(value);
}
export function parseAtomicBatchStatus(response, { batchId, chainId }) {
  if (!isRecord(response)) throw new Error("Invalid batch status: expected an object");
  const { version, id, status, atomic, receipts } = response;
  const fail = (reason) => {
    throw new Error(
      `Invalid batch status (${reason}): ${JSON.stringify({ version, id, chainId: response.chainId, status, atomic })}`
    );
  };
  if (typeof status !== "number" || !Number.isInteger(status) || status < 100 || status >= 700) {
    return fail("expected numeric v2 status");
  }
  if (version !== void 0 && version !== "2.0.0") return fail("unsupported version");
  if (id !== void 0 && !matchesBatchId(id, batchId)) return fail("batch ID mismatch");
  if (response.chainId !== void 0 && !matchesChain(response.chainId, chainId)) return fail("chain mismatch");
  if (status < 200 || status === 400) return { status };
  if (version !== "2.0.0" || !matchesBatchId(id, batchId)) return fail("missing completion identity");
  if (status >= 400 && receipts === void 0) return { status };
  if (!Array.isArray(receipts) || receipts.length === 0) return fail("missing receipts");
  const normalized = receipts.map((receipt) => {
    if (!isRecord(receipt)) return fail("invalid receipt");
    const receiptChain = receipt.chainId ?? response.chainId;
    if (!matchesChain(receiptChain, chainId)) return fail("receipt chain mismatch or missing chain");
    if (!isTransactionHash(receipt.transactionHash)) return fail("invalid receipt transaction hash");
    if (receipt.status !== "0x1" && receipt.status !== "0x0") return fail("invalid receipt status");
    return { transactionHash: receipt.transactionHash, status: receipt.status };
  });
  if (atomic !== true && atomic !== false) return fail("missing atomic execution flag");
  return { status, atomic, receipts: normalized };
}
